








 
import Vue from 'vue'
import DocumentosLoader from './visualizador/documentos-loader.vue';
import DocumentosContainer from './visualizador/documentos-container.vue';
import { PropType } from 'vue';

//import { Documento } from '../../../store/livro-digital/documentos-repository'
import { Livro } from '../../../store/livro-digital/livros-repository'



export default Vue.extend({
    props: {
        codigo_condominio: {
            type: Number,
            required: true
        },
        codigo_livro_digital: {
            type: Number,
            required: true
        },
        id_docsprime: {
            type: Number,
            required: true
        },
        livro: {
            type: Object as PropType<Livro>,
            required: true
        },
    },
    components: {
        DocumentosLoader,
        DocumentosContainer
    },
    methods: {
        close() {
            this.$emit('close')
        }
    }
})

